import * as React from 'react';
import { generateOneLinkUrl } from '@cian/appsflyer-onelink';

import { FoldersUnsupportedModal } from '../../components/FoldersUnsupportedModal';
import { useApplicationContext } from '../../utils/applicationContext';
import { trackClickOnBanner, trackShowBanner } from './tracking';
import { MOBILE_APP_UNSUPPORTED_BANNER_TITLE, downLoadUrl } from './constants';
// eslint-disable-next-line import/no-restricted-paths
import { setHideUnsupportedModal } from '../../../browser/utils/cookie/setHideUnsupportedModal';

interface IFoldersUnsupportedModalContainerV2Props {
  isModalAvailable: boolean;
}

export const FoldersUnsupportedModalContainerV2 = ({ isModalAvailable }: IFoldersUnsupportedModalContainerV2Props) => {
  const {
    custom: { platform },
  } = useApplicationContext();
  const [isOpen, setOpen] = React.useState(false);

  const [mobileBannerDownloadUrl, setMobileBannerDownloadUrl] = React.useState<string | null>(downLoadUrl);

  React.useEffect(() => {
    if (isModalAvailable) {
      setMobileBannerDownloadUrl(
        generateOneLinkUrl(mobileBannerDownloadUrl, 'mobile_site', MOBILE_APP_UNSUPPORTED_BANNER_TITLE),
      );

      setOpen(true);
      trackShowBanner(platform);
      setHideUnsupportedModal();
    }
  }, []);

  const handleModalClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  const handleButtonClick = React.useCallback(() => {
    trackClickOnBanner(platform);
  }, []);

  return (
    <FoldersUnsupportedModal
      url={mobileBannerDownloadUrl || ''}
      isOpen={isOpen}
      onClose={handleModalClose}
      onClick={handleButtonClick}
    />
  );
};
